/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const getapiendpoint = () => {
  if (process.env.REACT_APP_LOCAL_API === "true") {
    return window.location.origin;
  }
  if (
    window.location.host.includes("beta") ||
    window.location.host.includes("localhost")
  ) {
    return "https://api.catbeta.payments-security.amazon.dev";
  }
  return "https://api.cat.payments-security.amazon.dev";
};

const getauthdomain = () => {
  if (
    window.location.host.includes("beta") ||
    window.location.host.includes("localhost")
  ) {
    return "act-dashboard-beta.auth.us-east-1.amazoncognito.com";
  }
  return "act-dashboard.auth.us-east-1.amazoncognito.com";
};
const getuserpoolid = () => {
  if (
    window.location.host.includes("beta") ||
    window.location.host.includes("localhost")
  ) {
    return "us-east-1_hb3zH7trK";
  }
  return "us-east-1_vY9sbtxzK";
};
const getuserwebclientid = () => {
  if (
    window.location.host.includes("beta") ||
    window.location.host.includes("localhost")
  ) {
    return "53ga3o92akhpc3ttj7aka1mjra";
  }
  return "4kpqeeccinbtgof988tb8lhk2e";
};
const amplify = {
  Auth: {
    Cognito: {
      userPoolId: getuserpoolid(),
      userPoolClientId: getuserwebclientid(),
      loginWith: {
        oauth: {
          domain: getauthdomain(),
          redirectSignIn: [window.location.protocol + "//" + window.location.host],
          redirectSignOut: [window.location.protocol + "//" + window.location.host],
          scopes: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
          responseType: "code",
        },
      },
    },
  },
  API: {
    REST: {
      API: {
        endpoint: getapiendpoint(),
      },
    },
  },
};
export default amplify;
